import person from '@/api/person'
export default {
  data() {
    return {
      id: '',
      dataSource: [],
      titleTab: {
        'Special Issue Published In': 1,
        'As a Guest Editor': 2
      },
      titleIndex: 1,
      empty: {
        icon: 'iconfolder',
        title: 'No Data',
        text: ''
      }
    }
  },
  mounted() {
    this.id = this.$route.params.id
    this.getList()
  },
  methods: {
    async getList() {
      let list = []
      if (this.titleIndex === 1) {
        list = await person.special(this.id)
      } else {
        list = await person.guest(this.id)
      }
      this.dataSource = list
    },
    changeTitle(val) {
      this.titleIndex = val
      this.getList()
    }
  }
}
